(() => {
  'use strict';

  if (window.PWProductPriceFormatV3Loaded) return;
  window.PWProductPriceFormatV3Loaded = true;

  const PRICE_HOST_SELECTOR = [
    '.card__price',
    '.price',
    '.price__current',
    '.price-item',
    '.product-price',
    '.pw-product-price',
    '[data-pw-price-current]',
    '[data-pw-price-compare]',
    '.product-recommendations [class*="price"]',
    '.recommendations [class*="price"]',
    '.recently-viewed [class*="price"]'
  ].join(',');

  let scheduled = false;

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  function textNodesWithin(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) nodes.push(walker.currentNode);
    return nodes;
  }

  function preserveOuterWhitespace(original, replacement) {
    const leading = original.match(/^\s*/)?.[0] || '';
    const trailing = original.match(/\s*$/)?.[0] || '';
    return `${leading}${replacement}${trailing}`;
  }

  function normaliseThousands(value) {
    return String(value || '').replace(
      /(€\s*)(\d{1,3}(?:,\d{3})+)(?=(?:[.,]\d{2})?(?:\D|$))/g,
      (_match, currency, amount) => `${currency}${amount.replace(/,/g, '.')}`
    );
  }

  function formatInline(value) {
    return normaliseThousands(value).replace(
      /([,.])00(?=\s*(?:[A-Z]{3})?(?:$|[^\d]))/g,
      ',-'
    );
  }

  function markCents(node) {
    const parent = node.parentElement;
    if (!(parent instanceof HTMLElement)) return;

    parent.dataset.pwPriceCents = 'true';
    parent.style.setProperty('font-size', '1em', 'important');
    parent.style.setProperty('font-weight', 'inherit', 'important');
    parent.style.setProperty('line-height', 'inherit', 'important');
    parent.style.setProperty('vertical-align', 'baseline', 'important');
    parent.style.setProperty('position', 'static', 'important');
    parent.style.setProperty('inset', 'auto', 'important');
  }

  function formatHost(host) {
    if (!(host instanceof HTMLElement)) return;

    let nodes = textNodesWithin(host);

    nodes.forEach((node) => {
      const current = node.nodeValue || '';
      const formatted = formatInline(current);
      if (formatted !== current) node.nodeValue = formatted;
    });

    nodes = textNodesWithin(host);

    nodes
      .filter((node) => cleanText(node.nodeValue) === '00')
      .forEach((node) => {
        const ordered = textNodesWithin(host);
        const index = ordered.indexOf(node);
        const before = ordered
          .slice(0, index)
          .map((item) => item.nodeValue || '')
          .join('');

        if (!/€\s*\d/.test(before)) return;

        for (let cursor = index - 1; cursor >= 0; cursor -= 1) {
          const candidate = ordered[cursor];
          if (!/€\s*\d/.test(candidate.nodeValue || '')) continue;

          const formatted = normaliseThousands(candidate.nodeValue || '');
          if (formatted !== candidate.nodeValue) candidate.nodeValue = formatted;
          break;
        }

        node.nodeValue = preserveOuterWhitespace(node.nodeValue || '', ',-');
        markCents(node);
        host.dataset.pwFinalPrice = 'true';
      });

    if (/€\s*\d/.test(cleanText(host.textContent))) {
      host.dataset.pwFinalPrice = 'true';
    }
  }

  function collectHosts(root) {
    const hosts = new Set();

    if (root instanceof Element && root.matches(PRICE_HOST_SELECTOR)) hosts.add(root);
    root.querySelectorAll?.(PRICE_HOST_SELECTOR).forEach((element) => hosts.add(element));

    return hosts;
  }

  function enhance(root = document) {
    collectHosts(root).forEach(formatHost);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  }

  function init() {
    enhance();

    new MutationObserver((records) => {
      const relevant = records.some(
        (record) =>
          record.type === 'characterData' ||
          Array.from(record.addedNodes).some(
            (node) => node.nodeType === Node.ELEMENT_NODE
          )
      );

      if (relevant) schedule();
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
